import { uuid } from "uuidv4";
import { addCinemaFieldsToEventData, dataLayerPush, getCinemaExperience } from "../analytics";
import { trackEvent } from "./serverSide";
import { CinemaType, MovieType } from "../../types/entities";
import { getCinema } from "../../reducers";

export const trackCinemaBillboardLoad = (action: { cinemaId: number, movies: MovieType[] }, state): void => {
    const cinema: CinemaType = getCinema(state, action.cinemaId);

    const metaEventData = {
        content_ids: `billboard_${cinema.id}`,
        content_name: `Billboard ${cinema.name}`,
        content_type: 'product',
        event_source_url: window.location.href,
        currency: 'MXN',
        value: 0,
        content_category: `Cinema > ${getCinemaExperience(cinema)}`,
    };

    addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'ViewContent',
        uuid(),
        metaEventData
    );
    
    const googleEvent = {
        event: 'view_item_list',
        currency: 'MXN',
        value: 0,
        item_list_name: metaEventData.content_name,
        items: action.movies.map(movie => ({
            item_id: `movie_${movie.id}`,
            item_name: movie.name
        }))
    };

    dataLayerPush(googleEvent);
}